import { GALLERY } from "../data/site";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="bg-cocoa text-[#FAF3E7] py-20 md:py-32 grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7 reveal">
            <div className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">
              The Gallery
            </div>
            <h2 className="font-display text-4xl md:text-5xl mt-3 leading-tight">
              Up close with{" "}
              <span className="text-gold italic">fire & rice</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 text-[#FAF3E7]/75 reveal">
            <p>
              A moodboard of our kitchen — smoking handis, hand-pounded masala
              and the moment a sealed lid first cracks open.
            </p>
          </div>
        </div>

        <div className="mt-12 columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-6 [column-fill:_balance]">
          {GALLERY.map((src, i) => (
            <div
              key={src + i}
              data-testid={`gallery-item-${i}`}
              className="reveal mb-4 md:mb-6 break-inside-avoid overflow-hidden rounded-xl ring-1 ring-[#C8A14B]/30 group"
              style={{ transitionDelay: `${i * 40}ms` }}
            >
              <img
                src={src}
                alt={`Andhra Biryani Co gallery ${i + 1}`}
                className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
                style={{
                  aspectRatio: i % 3 === 0 ? "4 / 5" : i % 3 === 1 ? "1 / 1" : "3 / 4",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
